// extracted by mini-css-extract-plugin
export default {"sub-form-success-notification":"styles_sub-form-success-notification__APdat"};